import { render } from "./CustomCheckbox.vue?vue&type=template&id=7153ab5c&scoped=true&ts=true"
import script from "./CustomCheckbox.vue?vue&type=script&lang=ts"
export * from "./CustomCheckbox.vue?vue&type=script&lang=ts"

import "./CustomCheckbox.scss?vue&type=style&index=0&id=7153ab5c&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7153ab5c"]])

export default __exports__